import { useInfiniteQuery, useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { OptionWithSelect } from '../features/filters/FilterTypes';
import { Pagination } from '../types/common';
import { LeadGridItem } from '../types/Lead';
import { client } from '../utils/axios-client';

export const ServerStateKey = ['mass-update-leads-list'];
export const apiUri = '/api/leads';

export const useGetMassUpdateItems = (options: OptionWithSelect[], searchTerm: string, pageSize: number) => useInfiniteQuery<Pagination<LeadGridItem>>({
    queryKey: [...ServerStateKey, searchTerm, options],
    queryFn: ({ pageParam = 1 }) => {
        return client.post(`${apiUri}/v2/getpaginated`, { options: options, searchTerm: searchTerm, pageSize: pageSize, pageNumber: pageParam }).then((res) => res.data)
    },
    getNextPageParam: (lastPage, pages) => {
        if (lastPage.hasNextPage) return lastPage.pageNumber + 1;
        return false;
    }
})